function setupClipboardCopy(selector, attribute) {
    document.querySelectorAll(selector).forEach(function (button) {
      button.addEventListener('click', function () {
        const code = this.getAttribute(attribute);
        if (!code) return;
  
        navigator.clipboard.writeText(code).then(() => {
          const originalText = this.textContent;
          this.textContent = 'Copied!';
          setTimeout(() => {
            this.textContent = originalText;
          }, 2000);
        }).catch((err) => {
          console.error('Failed to copy:', err);
        });
      });
    });
  }
  
  setupClipboardCopy('.copy-clip', 'data-code');